<ng-container *ngIf="type === ColumnTypeEnum.OFFER">
  <gtd-ui-field-default-link
    *ngIf="offer || advertiser; else all"
    [link]="['/app/traffic-control/offers', offer?.id]"
    [rbacProperty]="rbacProperty"
    [displayData]="offer?.name"
    [relationData]="offer?.id"
  >
  </gtd-ui-field-default-link>
  <ng-template #all>All Offers</ng-template>
</ng-container>
<ng-container *ngIf="type === ColumnTypeEnum.ADVERTISER">
  <gtd-ui-field-default-link
    *ngIf="advertiser || offer; else all"
    [link]="['/app/advertisers/advertisers', advertiser?.id]"
    [rbacProperty]="rbacProperty"
    [displayData]="advertiser?.name"
    [relationData]="advertiser?.id"
  >
  </gtd-ui-field-default-link>
  <ng-template #all>All Advertisers</ng-template>
</ng-container>
